<a class="app-link" [href]="'tel:' + phoneNumber" [class.inherit-color]="inheritColor" data-testid="contact-phone">{{ linkText || (phoneNumber | phone) }}</a>
